import styled from 'styled-components';
import { toRem, theme } from '../../styles';

export const StyledErrorModal = styled.div`
  .inner-container {
    padding: 99px 113px;
    align-items: center;
    p {
      overflow-wrap: anywhere;
      text-align: center;
      span {
        font-size: ${toRem(16)};
      }
      @media ${theme.mediaQuery.allMobiles} {
        text-align: left;
      }
    }
    @media ${theme.mediaQuery.tabletOnly} {
      max-width: 801px;
      margin: 0 auto;
    }
    @media ${theme.mediaQuery.allMobiles} {
      padding: 64px 5px;
      align-items: flex-start;
      text-align: left;
    }
  }
  span {
    font-size: ${toRem(14)};
    line-height: 20px;
  }
  Button {
    min-width: 140px;
  }
  h1 {
    font: normal normal var(--t-title-l-font-weight) ${toRem(60)} / normal var(--t-title-font-family) !important;
  }
  h5 {
    font: normal normal var(--t-title-l-font-weight) ${toRem(30)} / ${toRem(36)} var(--t-title-font-family);
    margin-bottom: 4px;
    @media ${theme.mediaQuery.allMobiles} {
      margin-bottom: 15px;
    }
  }
  [class*='icon-']::before {
    padding-right: 8px;
    font-size: ${toRem(16)};
    color: var(--t-interactive-accent-color);
  }
  .icon-mail:before {
    position: relative;
    top: 3px;
    @media ${theme.mediaQuery.largeDesktop} {
      margin-left: 40px;
    }
  }
  .icon-mail {
    word-break: break-all;
    @media ${theme.mediaQuery.allMobiles} {
      margin-left: 0 !important;
    }
  }
  .icon-wrapper {
    @media ${theme.mediaQuery.allMobiles} {
      display: flex;
      flex-direction: column;
    }
    a {
      font: normal 400 var(--t-title-l-font-weight) ${toRem(30)} / ${toRem(36)} var(--t-title-font-family);
      &:nth-child(1) {
        @media ${theme.mediaQuery.allMobiles} {
          margin-bottom: 12px;
        }
      }
    }
  }
  .error-msg {
    text-align: left !important;
    p {
      padding: 0 !important;
      padding-top: 20px !important;
    }
  }
`;
